import { createQueryKey } from '@vueron/kiska/util';

import type { RemoteSupportApi } from '$viewer/type';

export const QUERY_KEY = {
  getRemoteSupport: createQueryKey<RemoteSupportApi.Get.Request>(
    'remoteSupportApi.get',
  ),
};
